import { type MatchUpInterface } from 'typedefs/store/scheduleTypes';
import { type ParticipantInterface } from 'typedefs/store/tmxTypes';
import { getAddress as participantAddress } from 'utils/participant';

export function getSeed(pId: string, groupMatchUpsWithContext: MatchUpInterface[]): number {
  const matchUp = groupMatchUpsWithContext.find((mUp) => {
    return mUp.sides.find((s) => s.participantId === pId);
  });
  return matchUp?.sides?.find((s) => s.participantId === pId)?.seedValue;
}

export function getAddress(participant: ParticipantInterface) {
  let addresses: string | undefined;
  if (participant) {
    const doubles = participant?.participantType === 'PAIR';
    if (!doubles) {
      const address = participantAddress(participant);
      if (address) addresses = `${address?.city ?? ''}${address?.city && ','} ${address?.state ?? ''}`;
    } else {
      addresses = participant?.individualParticipants
        ?.map((p) => {
          const address = participantAddress(p);
          const city = address?.city;
          const state = address?.state;
          return `${city ?? ''}${city && ','} ${state ?? ''}`;
        })
        ?.join('/');
    }
  }
  return addresses;
}
